export default __webpack_public_path__ + "64c534c7e1e166237a2612e01ea69731.png";